$(() => {
  $('.page-link').click(function (e) {
    const goTo = $(this).data('go-to');
    if (goTo) {
      e.preventDefault();
      window.location = $(this).attr('href') + goTo;
    }
  });
});
